/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update an existing document.
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    filename?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDocumentRequest
     */
    claimId?: number;
    /**
     * Document parsing status
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    parseStatus?: UpdateDocumentRequestParseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentRequest
     */
    parseError?: string;
}


/**
 * @export
 */
export const UpdateDocumentRequestParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type UpdateDocumentRequestParseStatusEnum = typeof UpdateDocumentRequestParseStatusEnum[keyof typeof UpdateDocumentRequestParseStatusEnum];


/**
 * Check if a given object implements the UpdateDocumentRequest interface.
 */
export function instanceOfUpdateDocumentRequest(value: object): value is UpdateDocumentRequest {
    return true;
}

export function UpdateDocumentRequestFromJSON(json: any): UpdateDocumentRequest {
    return UpdateDocumentRequestFromJSONTyped(json, false);
}

export function UpdateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'] == null ? undefined : json['filename'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'parseStatus': json['parseStatus'] == null ? undefined : json['parseStatus'],
        'parseError': json['parseError'] == null ? undefined : json['parseError'],
    };
}

export function UpdateDocumentRequestToJSON(json: any): UpdateDocumentRequest {
    return UpdateDocumentRequestToJSONTyped(json, false);
}

export function UpdateDocumentRequestToJSONTyped(value?: UpdateDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'claimId': value['claimId'],
        'parseStatus': value['parseStatus'],
        'parseError': value['parseError'],
    };
}

